import React, { useEffect } from 'react';

const Tax_SelectButton = ({ 
  values,           
  height,              
  width,             
  taxName,             
  taxPercentage,     
  setTaxPercentage,    
  setTaxName,         
  border               
}) => {


  // Handle change in the select dropdown
  const handleChange = (e) => {
    const selectedTaxKey = e.target.value;
    
    // Split the combined value into taxType and rate
    const [taxType, rate] = selectedTaxKey.split("_");

    
    // Find the selected tax object from the values array using the combination of taxType and rate
    const selectedTax = values.find(tax => `${tax.taxType}_${tax.rate}` === selectedTaxKey);
    
    // If the selected tax is found, update the taxName and taxPercentage state in the parent
    if (selectedTax) {
      setTaxName(selectedTax.taxType);     // Update the tax name (e.g., 'VAT', 'GST')
      setTaxPercentage(selectedTax.rate);  // Update the tax rate (e.g., 5, 12, 18)
    }
  };

  return (
    <div>
      <select
        style={{
          height: `${height}px`,
          width: `${width}px`,
          border: '1px solid rgb(226, 226, 226)',
          borderRadius: `${border ? border : '10px'}`,
          padding: '15px',
          backgroundColor: 'transparent',
        }}
        onChange={handleChange}
        value={`${taxName}_${taxPercentage}`}
      >
        {values?.map((tax, index) => (
          <option key={index} value={`${tax.taxType}_${tax.rate}`}>
            {`${tax.taxType.charAt(0).toUpperCase() + tax.taxType.slice(1)}: ${tax.rate}%`}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Tax_SelectButton;
